'use client';

import React from 'react';
import Footer from '@/components/organisms/footer';
import { FooterLink } from '@/components/organisms/footer';
import { TasticProps } from '../types';

interface Props {
  data?: any;
}

type INavigation = {
    label: string;
    link: any;
    open_in_new_tab:boolean
}

const FooterTastic = ({ data }: TasticProps<Props>) => {
  const columns = data?.data?.dataSource?.navigation?.map((nav: INavigation) => {
    return {
      header: nav?.label,
      links: nav?.link,
      openInNewTab: !!nav?.open_in_new_tab
    };
  });

  const dummyCopyright = '© Copyright 2026 Caroma Industries Limited.'
  return (
    <div className="fixed-screen-width lg:relative-width">
        <Footer
          logo={data?.data?.dataSource?.logo?.url}
          columns={data?.data?.dataSource?.navigation}
          socialMedia={data?.data?.dataSource?.social_media?.social_media_share}
          copyrightStatement={dummyCopyright}
        />
    </div>
  );
};

export default FooterTastic;
